// Send to device: which devices the tab lists, in order, and what the dialog does with the answer
// from sendToHiikerApp.

export type SendDeviceId = 'garmin' | 'suunto' | 'hiiker';

export interface SendDevice {
  id: SendDeviceId;
  name: string;
}

// Suunto only where this environment has Suunto API credentials.
export function sendDevices(suuntoAvailable: boolean): SendDevice[] {
  return [
    { id: 'garmin', name: 'Garmin' },
    ...(suuntoAvailable ? [{ id: 'suunto' as const, name: 'Suunto' }] : []),
    { id: 'hiiker', name: 'HiiKER' }
  ];
}

// The small line under the "Send to device" tab label, e.g. "Garmin, Suunto, HiiKER".
export function deviceNamesLine(devices: SendDevice[]): string {
  return devices.map(device => device.name).join(', ');
}

// `install`: no phone signed in to HiiKER can receive the push, so offer the app.
export type SendToAppOutcome = 'sent' | 'install' | 'notifications_off' | 'failed';

export function sendToAppOutcome(status: string | null | undefined): SendToAppOutcome {
  switch (status) {
    case 'SENT':
      return 'sent';
    case 'NO_DEVICES':
      return 'install';
    case 'NOTIFICATIONS_OFF':
      return 'notifications_off';
    default:
      return 'failed';
  }
}
